const Privacy = () => {
  return (
    <div className="py-12 text-gray-600">
      <div className="max-w-3xl mx-auto px-4 space-y-8">
        <h1 className="text-3xl font-bold">[개인정보처리방침]</h1>
        <div className="space-y-3">
          <p>
            ‘She App.’을 사용하실 때, 귀하는 본인과 직접 연관된 개인 정보를
            당사에 신탁하게 됩니다. 당사는 모든 조치를 강구하여 귀하가 맡긴
            정보를 보호합니다. 당사는 규정을 정하여, 유저의 데이터와 프라이버시
            권리를 보호하며, 그를 위한 모든 조치를 마련했습니다. 당사는 또한
            데이터 관리 관행에 투명성을 제공하고자 필요한 모든 조치를
            강구했습니다.
          </p>
          <p>
            또한 She App.의 개선 및 사용자 편의성 재고를 위한 용도에 한하여
            개인정보 보호법 제 15조 및 제 17조에 따라 이용자의 개인정보를
            수집∙이용 및 제3자에게 제공하고자 합니다. 개인정보의 수집 범위는
            다음과 같습니다.
          </p>
          <ol className="list-inside px-3 list-decimal space-y-1">
            <li>
              항목 : 이름, 성별/생년월일/휴대전화번호/이메일/서비스 및 App.의
              사용기록
            </li>
            <li>수집방법 : SHE App. 및 서지에 의해 수집</li>
            <li>보유기간 : 동의서의 동의일로부터 1년</li>
            <li>보유근거 : 서비스 제공</li>
            <li>보유대상 : 만 14세 이상 개인정보 제공 동의자</li>
          </ol>

          <p>
            개인정보 수집의 ㈜필메디의 방침은 2022년 2월 1일부터 시행하며
            개인정보 이용 동의에 따른 보관기간까지 유효합니다. 개인정보 이용
            정보주체는 다음과 같은 권리를 행사할 수 있습니다.
          </p>
          <ol className="list-inside px-3 list-decimal space-y-1">
            <li>개인정보 열람의 요구</li>
            <li>개인정보 수정의 요구</li>
            <li>개인정보 삭제의 요구</li>
            <li>개인정보 처리의 요구</li>
          </ol>
          <p>
            각 항의 권리행사는 개인정보 보호법 시행규칙에 의거 서면, 우편,
            모사전송(FAX)를 통해 권리 요구가 가능하며 ㈜필메디는 이에 대하여
            즉시 조치할 의무가 있습니다. 또 한 정보주체의 법정대리인 혹은 위임자
            등 대리인을 통해 하실 수 있습니다.
          </p>
          <p>내용을 자세히 읽으신 후 동의 여부를 결정하여 주십시오.</p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">
            □ 개인정보 국외 보관에 관한 내용
          </h3>
          <p>
            ㈜필메디는 정보주체로부터 수집, 생성, 분석한 정보를 Google 및
            Amazon이 보유하고 있는 데이터베이스에 저장합니다. 해당
            데이터베이스는 원칙적으로 정보주체의 개인정보에 대한 검색, 변경,
            삭제 등을 하지 않습니다. 개인정보 보관 데이터베이스의 개인정보
            보유는 정보주체의 회원 탈퇴, 서비스 종료, 위탁계약 종료까지
            유지됩니다.
          </p>
          <p>
            데이터베이스의 이용은 제3자 제공받는 기관에서 위탁하여 관리합니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">□ 개인정보 수집∙이용 내역</h3>
          <div className="border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th className="text-left px-4 py-2">항목</th>
                  <th className="text-left px-4 py-2">수집목적</th>
                  <th className="text-left px-4 py-2">보유∙이용기간</th>
                </tr>
              </thead>
              <tbody>
                <tr className="divide-x divide-gray-200">
                  <td className="px-4 py-2">
                    이름, 성별, 생년월일, 휴대전화번호, 이메일
                  </td>
                  <td className="px-4 py-2">귀하의 신원을 확인</td>
                  <td className="px-4 py-2">1년</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            ※ 위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있습니다.
            그러나 동의를 거부할 경우 앱을 사용할 수 없습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">□ 민감정보 처리 내역</h3>
          <div className="border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th className="text-left px-4 py-2">항목</th>
                  <th className="text-left px-4 py-2">수집목적</th>
                  <th className="text-left px-4 py-2">보유∙이용기간</th>
                </tr>
              </thead>
              <tbody>
                <tr className="divide-x divide-gray-200">
                  <td className="px-4 py-2">테스트 촬영 결과</td>
                  <td className="px-4 py-2">테스트 결과 분석/수치화</td>
                  <td className="px-4 py-2">1년</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            ※ 위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있습니다.
            그러나 동의를 거부할 경우 앱을 사용할 수 없습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">□ 개인정보 제3자 제공 내역</h3>
          <div className="border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="divide-x divide-gray-200">
                  <th className="text-left px-4 py-2">제공받는 기관</th>
                  <th className="text-left px-4 py-2">제공목적</th>
                  <th className="text-left px-4 py-2">제공하는 항목</th>
                  <th className="text-left px-4 py-2">보유∙이용기간</th>
                </tr>
              </thead>
              <tbody>
                <tr className="divide-x divide-gray-200">
                  <td className="px-4 py-2">고북이</td>
                  <td className="px-4 py-2">
                    테스트 결과 분석 및 분석수치 보관
                  </td>
                  <td className="px-4 py-2">테스트 촬영 결과</td>
                  <td className="px-4 py-2">1년</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            ※ 위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있습니다.
            그러나 동의를 거부할 경우 앱을 사용할 수 없습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
